function pad2(value) {
    return String(value).padStart(2, "0");
}

export function formatReviewThreadLocation(range) {
    if (!range?.start_line) {
        return "";
    }

    const startLine = Number(range.start_line);
    const startCol = Number(range.start_col);
    const endLine = Number(range.end_line || range.start_line);
    const endCol = Number(range.end_col || range.start_col);

    if (!startLine || !startCol || !endLine || !endCol) {
        return "";
    }

    return `L${startLine}:${startCol}-L${endLine}:${endCol}`;
}

export function getReviewThreadSelectedText(threadOrRange) {
    const range = threadOrRange?.creation_anchor_range || threadOrRange;
    return range?.selected_text || "";
}

export function getReviewThreadFirstMessage(thread) {
    return thread?.messages?.[0] || null;
}

export function getReviewThreadExtraMessageCount(thread) {
    const totalMessageCount = Array.isArray(thread?.messages) ? thread.messages.length : 0;
    return Math.max(0, totalMessageCount - 1);
}

export function getReviewThreadMessageCountLabel(thread) {
    const totalMessageCount = Array.isArray(thread?.messages) ? thread.messages.length : 0;
    return `${totalMessageCount}개 메시지`;
}

export function getReviewThreadStatusLabel(thread) {
    return thread?.is_resolved ? "해결됨" : "열림";
}

export function formatReviewThreadCreatedAt(createdAt) {
    if (!createdAt) {
        return "";
    }

    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) {
        return createdAt;
    }

    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())} ${pad2(date.getHours())}:${pad2(
        date.getMinutes(),
    )}`;
}
